const ISO_DATE_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
const YEAR_RE = /^(\d{4})$/;

/** Display value for the public timeline column. */
export function formatMilestoneDate(value: string): string {
  const trimmed = value.trim();
  const iso = ISO_DATE_RE.exec(trimmed);
  if (iso) {
    const [, year, month, day] = iso;
    const date = new Date(Number(year), Number(month) - 1, Number(day));
    if (Number.isNaN(date.getTime())) return trimmed;
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  }
  if (YEAR_RE.test(trimmed)) return trimmed;
  return trimmed;
}

/** Map stored milestone date to `<input type="date">` value. */
export function milestoneDateToInput(value: string): string {
  const trimmed = value.trim();
  if (ISO_DATE_RE.test(trimmed)) return trimmed;
  const year = YEAR_RE.exec(trimmed);
  if (year) return `${year[1]}-01-01`;
  return "";
}

/** Normalize date picker output for API storage. */
export function milestoneDateFromInput(value: string): string {
  return value.trim();
}

/** Keep legacy year-only values unless the admin picked a specific date. */
export function milestoneDateForSave(nextValue: string, previousValue: string): string {
  const next = nextValue.trim();
  const previous = previousValue.trim();
  const iso = ISO_DATE_RE.exec(next);
  if (iso && iso[2] === "01" && iso[3] === "01" && YEAR_RE.test(previous) && iso[1] === previous) {
    return previous;
  }
  return next;
}
